export default function (text, type) {
  jQuery('<div>', {
    class: `notice notice--${type}`,
  })
    .html(text)
    .appendTo('body')
    .on('click', function () {
      $(this).remove();
    })
    .hide()
    .slideToggle(300)
    .delay(3000)
    .slideToggle(300)
    .queue(function () {
      $(this).remove();
    });
}
